import { useQuery, queryOptions } from '@tanstack/react-query';

import { STALE_TIMES } from '#lib/queryConstants';

import { listIntegrations } from '../../api/crmApi';

export const integrationsKeys = {
	all: ['crm', 'integrations'],
	list: () => ['crm', 'integrations', 'list'],
};

export const integrationsListOptions = () =>
	queryOptions({
		queryKey: integrationsKeys.list(),
		queryFn: async () => {
			const res = await listIntegrations();
			// Attach calendarConnections as a property on the array for co-located access
			const integrations = res.integrations ?? [];
			integrations.calendarConnections = res.calendarConnections ?? [];
			return integrations;
		},
		staleTime: STALE_TIMES.FREQUENT,
	});

export function useIntegrationsList() {
	return useQuery(integrationsListOptions());
}
